import React, { memo } from "react";
import { Box } from "@chakra-ui/react";

interface IProps {
  isOpen: boolean;
  onClose: () => void;
}

const ClickOutsideBackdrop = ({ isOpen, onClose }: IProps) => {
  if (!isOpen) return null;

  return (
    <Box style={{ position: "fixed", inset: 0, zIndex: 1 }} onClick={onClose} />
  );
};

export default memo(ClickOutsideBackdrop);
